export function buildPath(path: string, host: string): string {
  const [, , suffix = 'api/', postfix] = path.match(/^(\/)?(api\/)?(.*)$/) as [string, string | undefined, string | undefined, string];

  return `${host}${suffix}${postfix}`;
}
